export default __webpack_public_path__ + "static/media/pre-2013.e640d97a.png";